
export class ValueSet{
    pointer : Pointer;
    objectValue : any;

    constructor(public valueArray : any[], private idFieldName : string, pointer : Pointer = null){
        if(!pointer)
            pointer = new Pointer(() => this.objectValue, x => this.objectValue = x);

        this.pointer = pointer;
    }

    get selectedIdValue(){
        let realValue = this.pointer.get() || {};
        return realValue[this.idFieldName];
    }
    set selectedIdValue(value){
        console.log("Setting value: " + value);
        let realValue = null;
        if(value)
            realValue = this.valueArray.find(x => x[this.idFieldName] == value)

        console.log("Setting realValue: " + JSON.stringify(realValue));
        if(value && !realValue)
            console.log(`not found (${this.idFieldName}) in values: ` + JSON.stringify(this.valueArray));

        this.pointer.set(realValue);
    }
}

export class Pointer{
    constructor(private getter, private setter){

    }

    get(){
        return this.getter();
    }
    set(value){
        this.setter(value);
    }
}